import { useTranslation } from 'react-i18next'
import { ArrowPathRoundedSquareIcon } from '@heroicons/react/24/outline'
import { useStartHealthCycle } from './useStartHealthCycle'

// VH-227: "Start health cycle" on an analysed blood test — opens the new cycle.
export function StartHealthCycleButton({ bloodTestId, questions = [], className = '' }) {
  const { t } = useTranslation()
  const { start, discardAndRestart, openExisting, dismissConflict, conflict, isPending, error } = useStartHealthCycle()

  return (
    <div className={className}>
      <button
        type="button"
        onClick={() => start({ bloodTestId, questions })}
        disabled={isPending}
        className="btn-primary inline-flex items-center text-sm"
      >
        <ArrowPathRoundedSquareIcon className="h-4 w-4 mr-2" aria-hidden="true" />
        {isPending ? t('healthCycle.start.starting') : t('healthCycle.start.button')}
      </button>
      {error && (
        <p className="text-xs text-red-600 mt-1" role="alert">
          {t(`healthCycle.errors.${error}`, t('healthCycle.errors.generic'))}
        </p>
      )}
      {conflict && (
        <div className="mt-2 border border-yellow-200 bg-yellow-50 rounded-md p-3 text-sm" role="alertdialog">
          <p className="text-yellow-800">{t('healthCycle.start.draftExists')}</p>
          <div className="flex flex-wrap gap-2 mt-2">
            <button type="button" className="btn-outline text-xs" onClick={openExisting}>
              {t('healthCycle.start.openDraft')}
            </button>
            <button type="button" className="btn-outline text-xs" onClick={discardAndRestart} disabled={isPending}>
              {t('healthCycle.start.discardDraft')}
            </button>
            <button type="button" className="text-xs text-gray-600 underline" onClick={dismissConflict}>
              {t('common.cancel')}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default StartHealthCycleButton
